import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2e0684de"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "LAOT 终端网络管理平台", -1))
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sub-title" }, "设备情况", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sub-title" }, "线路情况", -1))

import { onMounted, ref } from 'vue';
import { request } from '@/util/request';


export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const data = ref();

function dataGet(data: any, status: string) {
  return data?.count?.find((i: any) => i.status === status)?.count || 0;
}

function dataCount(data: any) {
  return (
    data?.count
      ?.map((i: any) => i.count)
      ?.reduce((a: any, b: any) => a + b, 0) || 0
  );
}

onMounted(async () => {
  data.value = await request('/management/index/index');
  console.log(data.value);
});

return (_ctx: any,_cache: any) => {
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_statistic = _resolveComponent("a-statistic")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    (data.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(_component_a_row, { gutter: [16, 16] }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_card, { size: "small" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(data.value.content?.notification), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_card, { size: "small" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        innerHTML: data.value.content?.kefu
                      }, null, 8, _hoisted_2)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _hoisted_3,
          _createVNode(_component_a_row, { gutter: 16 }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, { span: 6 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_card, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_statistic, {
                        title: "设备数",
                        value: dataCount(data.value.device),
                        style: {"margin-right":"50px"}
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, { span: 6 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_card, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_statistic, {
                        title: "在线",
                        value: dataGet(data.value.device, 'online'),
                        "value-style": { color: '#3f8600' }
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, { span: 6 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_card, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_statistic, {
                        title: "异常",
                        value: dataGet(data.value.device, 'error'),
                        "value-style": { color: '#cf1322' }
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, { span: 6 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_card, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_statistic, {
                        title: "离线",
                        value: dataGet(data.value.device, 'offline')
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _hoisted_4,
          _createVNode(_component_a_row, { gutter: 16 }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, { span: 6 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_card, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_statistic, {
                        title: "线路数",
                        value: dataCount(data.value.proxy)
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, { span: 6 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_card, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_statistic, {
                        title: "正常线路",
                        value: dataGet(data.value.proxy, 'normal'),
                        "value-style": { color: '#3f8600' }
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, { span: 6 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_card, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_statistic, {
                        title: "异常线路",
                        value: dataGet(data.value.proxy, 'error'),
                        "value-style": { color: '#cf1322' }
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, { span: 6 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_card, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_statistic, {
                        title: "未检测线路",
                        value: dataGet(data.value.proxy, 'unknown')
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})